import asyncAction from '../asyncAction';

const FETCH_OFFER_TYPES = asyncAction('FETCH_OFFER_TYPES');
const FETCH_STATUS_TYPES = asyncAction('FETCH_STATUS_TYPES');

export { FETCH_OFFER_TYPES, FETCH_STATUS_TYPES };
